module.exports = __webpack_public_path__ + "static/media/blog-details-main.ad4a39db.jpg";